import { useLazyQuery } from "@apollo/client"
import { USER_SEARCH } from "../queries/userSearch"

interface UserSearchInput {
  search: string
  excludes?: number[]
  tournamentId?: number
  organizer?: boolean
}

export const useUserSearch = () => {
  const [searchUsers, { data, loading, error }] = useLazyQuery(USER_SEARCH)

  const searchForUsers = async (input: UserSearchInput) => {
    try {
      const { data: result } = await searchUsers({
        variables: {
          UserSearchInput: input,
        },
      })
      return result?.UserSearch
    } catch (err) {
      console.error("Error searching users:", err)
      throw err
    }
  }

  return {
    searchForUsers,
    searchResults: data?.UserSearch?.Persons || [],
    loading,
    error,
  }
}
